import axios from 'axios';
import User from '../../models/User'

const state = function () {
    return {
        user: null,
        q: null,
        search_mode: 'all',
        env: window.envApp
    };
};

const mutations = {
    SET(state, data) {
        state.user = data;
    },
    SET_Q(state, data) {
        state.q = data
    },
    SET_SEARCH_MODE(state, data) {
        state.search_mode = data
    }
};

const actions = {
    set({
        commit
    }, data) {
        commit('SET', data);
    },
    setQ({
        commit
    }, data) {
        commit('SET_Q', data);
    },
    setSearchMode({
        commit
    }, data) {
        commit('SET_SEARCH_MODE', data);
    },
    setUser({commit}) {
        return axios.get('/me').then((r)=>{
            if( r.data.data ) {
                var user = new User(r.data.data)
                commit('SET', user)
            }
        })
    }
};

const getters = {
    user: (state) => state.user,
    q: (state) => state.q,
    search_mode: (state) => state.search_mode,
    env: (state) => state.env,
};

let moduleStore = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default moduleStore;
